export const BUSINESS_PHONE = "7132052971";
export const BUSINESS_PHONE_FORMATTED = "(713) 205-2971";
export const BRAND = "PowerSaver TX";
export const OWNER_FIRST_NAME = "Jeffrey";

export const SERVICES_OF_INTEREST = [
    "Electricity",
    "Internet",
    "TV / Cable",
    "Home Security",
    "Mobile Phone",
    "Natural Gas",
    "Payment Processing",
    "Healthcare",
];

export const CUSTOMER_TYPES = [
    { id: "homeowner", label: "Homeowner", description: "You own your home and pay the electric bill." },
    { id: "renter", label: "Renter", description: "You rent an apartment, condo, or house." },
    { id: "moving", label: "Moving to a new address", description: "You need service connected soon." },
    { id: "business", label: "Business owner", description: "You pay a commercial electric bill." },
    { id: "other", label: "Other", description: "Something else - we can still help." },
];

export const SITUATIONS = [
    "I need electricity at a new address",
    "I want to compare my current plan",
    "My contract is ending soon",
    "I want to explore available options",
    "I need electricity for my business",
];

export const USAGE_BUCKETS = [
    "Under 500 kWh",
    "500 - 1,000 kWh",
    "1,000 - 2,000 kWh",
    "Over 2,000 kWh",
    "I don't know",
];

export const MOVE_DATES = [
    "Within 7 days",
    "Within 30 days",
    "1-3 months",
    "Just researching",
];

export const CONTACT_METHODS = [
    { id: "phone", label: "Phone call" },
    { id: "text", label: "Text message" },
    { id: "email", label: "Email" },
];

export const BUSINESS_TYPES = [
    "Restaurant",
    "Barber shop / Salon",
    "Retail store",
    "Convenience store",
    "Small office",
    "Warehouse",
    "Property manager / Landlord",
    "Other",
];

export const US_STATES = [
    "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
    "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
    "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY","DC",
];
